<template>
  <div>
    <!-- eslint-disable max-len -->
    <div class="page-topbar">
      <div class="page-topbar__title">
        Settings
      </div>
    </div>
    <tab-nav :tabs="navItems" />
    <template v-if="fetching">
      <div class="empty-state">
        <loader :size="100" />
      </div>
    </template>
    <template v-else>
      <div class="configuration border">
        <div class="m-1">
          <h3>Device Alarm Settings (Global)</h3>
          <p class="m-0">
            For key cabinets and safes, it is particularly valuable to configure an alarm that
            sounds when a door is held open for a certain length of time.
            <br />
            This is a global setting and will be configured across all of your cabinet devices
            ('Door' devices will not be affected).
            <br /><br />
            To disable the alarm, set the alarm to 0 minutes.
          </p>
          <h5>SET ALARM TIME</h5>
          <vue-slider
            id="slider-alarm-time"
            v-model="sliderValue"
            class="m-3 ml-2"
            :marks="sliderMarks"
            :min="0"
            :max="900"
            :interval="1"
            :tooltip-formatter="tooltipFormatter"
            :tooltip="'always'"
          >
          </vue-slider>
          <div class="flex-grid configuration-footer">
            <button
              id="submit-alarm-settings"
              class="btn"
              @click="submit()"
            >
              update
            </button>
          </div>
        </div>
      </div>
    </template>
    <!-- eslint-enable max-len -->
  </div>
</template>

<script>
// Components
import Loader from '@/components/loader.vue'
import TabNav from '@/components/tabNav.vue'
import VueSlider from 'vue-slider-component'

// Queries
import settingQueries from '@/graphql/settings.js'

// Mixins
import configurationNavMixin from '@/mixins/configurationNavMixin'

export default {
  name: 'DeviceAlarmSettings',
  components: {
    Loader,
    TabNav,
    VueSlider,
  },
  mixins: [configurationNavMixin, settingQueries],
  data() {
    return {
      fetching: false,
      sliderValue: 0,
      sliderMarks: {
        0: 'Disabled',
        60: '1min',
        180: '3min',
        300: '5min',
        600: '10min',
        900: '15min',
      },
      tooltipFormatter: (v) => {
        return this.convertSecondsToMmss(v)
      },
    }
  },
  created() {
    this.fetchSettings()
  },
  methods: {
    async submit() {
      this.fetching = true
      try {
        await this.updateSettingsDoorAlarmMutation(this.sliderValue)
        this.fetching = false
        this.displayAlert('success', 'Settings updated.')
      } catch (error) {
        this.fetching = false
        this.displayAlert('fail', 'Unable to update settings.')
        console.log(error)
      }
    },
    async fetchSettings() {
      this.fetching = true
      try {
        const {doorOpenAlarmSeconds} = await this.listSettingsQuery()

        if (doorOpenAlarmSeconds === null) {
          this.sliderValue = 0
        } else {
          this.sliderValue = doorOpenAlarmSeconds
        }

        this.fetching = false
      } catch (error) {
        this.fetching = false
        this.displayAlert('fail', 'Unable to fetch setting.')
        console.log(error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.configuration {
  max-width: 1300px;
  &-footer {
    @include flex-justify-content(flex-end);
  }
}
.custom-mark {
  position: absolute;
  top: 10px;
  transform: translateX(-50%);
  white-space: nowrap;
}
</style>
